import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import React from "react";
import { SearchHelper } from "../SearchHelper";
import { PlanningApplicationSearchState } from "./PlanningApplicationSearchState";
import "../Search.css";
import { PlanningApplicationsFilter } from "@shared/publicportal/contracts/PlanningApplicationsFilter";

interface PlanningApplicationSimpleSearchProps {
    state: PlanningApplicationSearchState;
    setter: (modifier: Partial<PlanningApplicationsFilter>) => void;
}

const PlanningApplicationSimpleSearch: React.FC<PlanningApplicationSimpleSearchProps> = (props) => {
    if (props.state.searchType === "Advanced") {
        return (
            <Grid container className="search-container search-container-simple" sx={{ width: { sm: "100%", md: "80%", lg: "60%", xl: "50%" } }}>
                {getContent()}
            </Grid>
        );
    }
    return (
        <>
            <Grid container className="search-container search-container-simple">
                {getContent()}
            </Grid>
        </>
    );

    function getContent() {
        return (
            <>
                <Grid size={{ xs: 12, md: 12, xl: 12 }}>
                    <Typography variant="h5">Reference</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: props.state.searchType === "Advanced" ? 6 : 12, xl: props.state.searchType === "Advanced" ? 6 : 12 }}>
                    <TextField
                        name="appRef"
                        value={props.state.filter.appRef}
                        onChange={(event) => props.setter({ appRef: event.target.value })}
                        key="app-Reference-key"
                        size="small"
                        id="app-Reference"
                        label="Application Reference"
                        variant="outlined"
                        className="min-width-18rem"
                    />
                </Grid>
                <Grid size={{ xs: 12, md: props.state.searchType === "Advanced" ? 6 : 12, xl: props.state.searchType === "Advanced" ? 6 : 12 }}>
                    <Autocomplete
                        options={props.state.applicationStatuses?.length ? props.state.applicationStatuses : []}
                        id="app-Status"
                        className="search-form-autocomplete-field autocomplete-width-18rem"
                        key="app-Status-key"
                        size="small"
                        inputValue={props.state.filter.status}
                        value={props.state.filter.status?.length ? props.state.filter.status : null}
                        onInputChange={(event, value) => event && props.setter({ status: value })}
                        renderInput={(params) => SearchHelper.renderAutocompleteInput(params, "Status")}
                    />
                </Grid>
            </>
        );
    }
};

export default PlanningApplicationSimpleSearch;
